var _effectorFileName = "/builds/gmini/front-common/src/forge-viewer/service/findElemetFromViewer.ts";
import { createEvent } from 'effector';
export var findElementFromViewer = createEvent({
  name: "findElementFromViewer",
  sid: "-du8kk2"
});